import React from "react";
import Logo from "images/lucid-modules.svg"
import { Link } from "gatsby";

const Header = ({ nav = true }: {
  nav?: boolean
}) => {
  return (
    <header className="absolute w-full z-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Site branding */}
          <div className="shrink-0 mr-4">
            {/* Logo */}
            <Link className="block"
                  to="/"
                  aria-label="Lucid Modules Home"
            >
              <Logo />
            </Link>
          </div>
          {/* Desktop navigation */}
          {nav &&
            <nav className="flex grow">
              {/* Desktop menu links */}
              <ul className="flex grow justify-end flex-wrap items-center">
                <li>
                  <Link className="font-medium text-lucid-300 hover:text-lucid-300 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out"
                        to="/contact"
                  >Contact</Link>
                </li>
                <li className="ml-3">
                  <Link className="btn-sm text-white bg-accent-500 hover:bg-accent-600 w-full shadow-sm group"
                        to="/blog"
                  >
                    Blog <span className="tracking-normal text-accent2-300 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">-&gt;</span>
                  </Link>
                </li>
              </ul>
            </nav>
          }
        </div>
      </div>
    </header>
  );
};

export default Header;
